import layout from "../pages/layout";
import NotFound from "../pages/404";
import Main from "../pages/main";
import Payment from "../pages/payment/payment";
import GiftPayment from "../pages/payment/gift";
import Transaction from "../pages/transaction/transaction";
import Gateway from "../pages/gateway/gateway";
import BillDetails from "../pages/main/bill/billDetails";
import BillInfo from "../pages/main/bill/billInfo"
import BillPayment from "../pages/main/bill/billPayment"
import GiftCardView from "../pages/main/gift-card/index";
import GiftCardItemsView from "../pages/main/gift-card/items";

export interface Iroutes {
  path: string;
  header: boolean;
  footer: boolean;
  Component: any;
  exact: boolean;
  reverse: boolean;
  Layout: any;
  wrapperClassName: string;
  backButton?: any;
  title?: string;
  render?: any;
  backLink?: string;
  filterButton?: string;
}

const routes: Iroutes[] = [
  {
    path: "/",
    title: "بسته اینترنت",
    header: true,
    footer: true,
    Component: Main,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/payment",
    title: "بسته اینترنت",
    header: true,
    footer: true,
    Component: Payment,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/transaction",
    title: "بسته اینترنت",
    header: true,
    footer: true,
    Component: Transaction,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/billDetails",
    title: "پرداخت قبوض",
    header: true,
    footer: true,
    Component: BillDetails,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/billInfo",
    title: "پرداخت قبوض",
    header: true,
    footer: true,
    Component: BillInfo,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/billPayment",
    title: "پرداخت قبوض",
    header: true,
    footer: true,
    Component: BillPayment,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/gateway",
    header: true,
    title: "اطلاعات کارت",
    footer: true,
    Component: Gateway,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/gift-card/",
    title: "گیفت کارت",
    header: true,
    footer: true,
    Component: Main,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/gift-card/:gid",
    title: "گیفت کارت",
    header: true,
    footer: true,
    Component: GiftCardItemsView,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "/payment/gift",
    title: "بسته اینترنت",
    header: true,
    footer: true,
    Component: GiftPayment,
    exact: true,
    reverse: true,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
  },
  {
    path: "*",
    header: true,
    footer: true,
    Component: NotFound,
    exact: false,
    reverse: false,
    Layout: layout,
    wrapperClassName: "customContainer customBg",
    backButton: "/",
  },
];

export default routes;
